/* stylelint-disable selector-class-pattern */

.link {
  color: var(--x-color-action);
}

.linkAlike {
  color: var(--x-color-action);
  cursor: pointer;

  &:hover {
    color: var(--x-color-text-accent-active);
    text-decoration: underline;
  }
}

.linkAlike.active {
  color: var(--x-color-text-accent-active);
}

.linkButton {
  display: inline-flex;
  align-items: center;
  padding: 0;
  color: var(--x-color-action);

  :global {
    span {
      text-transform: none;
    }
  }
}

.rightActionsBlock {
  display: flex;
  align-items: center;
}
